import clsx from 'clsx';
import i18n from 'i18n-react';

import type { FreeHotelItem, PremiumHotelItem } from 'hooks/useDirectoryData/types';

import c from './_mapCard.module.scss';

export interface MapCardProps {
  marker: { kind: 'premium'; hotel: PremiumHotelItem } | { kind: 'free'; hotel: FreeHotelItem };
  onViewProfile: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export function MapCard({ marker, onViewProfile, onMouseEnter, onMouseLeave }: MapCardProps) {
  if (marker.kind === 'premium') {
    const { hotel } = marker;
    return (
      <div
        className={clsx('map-card', c.card)}
        onClick={onViewProfile}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className={clsx('map-card__body', c.body)}>
          <span className={clsx('map-card__name', c.name)}>{hotel.propertyName}</span>
          {hotel.sub_catname && <span className={clsx('map-card__category', c.category)}>{hotel.sub_catname}</span>}
          <span className={clsx('map-card__cta', c.cta)}>{i18n.translate('directoryView.viewNow')}</span>
        </div>
      </div>
    );
  }

  const { hotel } = marker;
  const subtitle = hotel.cuisine ?? hotel.cat_name;

  return (
    <div
      className={clsx('map-card', c.card)}
      onClick={onViewProfile}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={clsx('map-card__body', c.body)}>
        <span className={clsx('map-card__name', c.name)}>{hotel.company}</span>
        {hotel.city && <span className={clsx('map-card__detail', c.detail)}>{hotel.city}</span>}
        {hotel.phone && <span className={clsx('map-card__detail', c.detail)}>{hotel.phone}</span>}
        {subtitle && <span className={clsx('map-card__detail', c.detail)}>{subtitle}</span>}
        <span className={clsx('map-card__cta', c.cta)}>{i18n.translate('directoryView.viewNow')}</span>
      </div>
    </div>
  );
}
